export const isInViewportY = (
  node,
  { offset = { top: 0, bottom: 0 }, entirely = true },
) => {
  const { top: nodeTop, bottom: nodeBottom } = node.getBoundingClientRect();
  const viewportTop = offset.top;
  const viewportBottom = window.innerHeight - offset.bottom;
  const isInViewport = entirely
    ? nodeTop >= viewportTop && nodeBottom <= viewportBottom
    : (nodeTop >= viewportTop && nodeTop <= viewportBottom) ||
      (nodeBottom >= viewportTop && nodeBottom <= viewportBottom);
  return isInViewport;
};

export const scrollTo = (node, { behavior = 'smooth', offset = 0 }) => {
  window.scrollTo({
    behavior,
    top:
      node.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  });
};
